import { ReactNode } from "react";

import Button from "@vfuk/core-button";
import type { ButtonProps } from "@vfuk/core-button/dist/Button.types";
import Container from "@vfuk/core-container";
import type { ContainerProps } from "@vfuk/core-container/dist/Container.types";
import Heading from "@vfuk/core-heading/";
import Icon from "@vfuk/core-icon";
import Paragraph from "@vfuk/core-paragraph";
import Spacing from "@vfuk/core-spacing/";

import { Stack } from "../Stack";

interface IconScreenProps {
  children?: ReactNode;
  title: string;
  description?: string;
  icon?: string;
  buttonText?: string;
  buttonOnClick?: () => void;
  buttonAppeareance?: ButtonProps["appearance"];
  group?: string;
  appearance?: ContainerProps["appearance"];
}

export const IconScreen = ({
  children,
  title,
  description,
  icon,
  buttonText,
  buttonOnClick,
  group,
  appearance,
  buttonAppeareance,
}: IconScreenProps) => {
  return (
    <Container appearance={appearance || "primary"}>
      <Spacing
        spacingLevel={{
          bottom: 12,
          top: 12,
        }}
      >
        <Stack justifyContent="center">
          <Icon
            size={4}
            name={icon || "warning"}
            group={group || "hifiLight"}
          />
        </Stack>

        <Heading size={3} justify="center">
          {title}
        </Heading>
        <Paragraph justify="center">{description}</Paragraph>

        {buttonText && (
          <Spacing spacingLevel={{ bottom: 6, top: 6 }}>
            <Stack justifyContent="center">
              <Button
                text={buttonText}
                appearance={buttonAppeareance || "primary"}
                onClick={buttonOnClick}
              />
            </Stack>
          </Spacing>
        )}

        <Spacing spacingLevel={{ bottom: 6, top: 12 }}>{children}</Spacing>
      </Spacing>
    </Container>
  );
};
